import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberFormat'
})
export class NumberFormatPipe implements PipeTransform {

  transform(value: any): any {
    let formating: string = '';
    if (value.toString().indexOf(".") == -1) {
      formating = value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    } else {
      formating = value.toString().replace(/\d(?=(\d{3})+\.)/g, '$&,');
    }
    let numberFormated: string = '';
    for (var i = 0; i < formating.length; i++) {
      if (formating.charAt(i) == ',') {
        numberFormated += '.';
      } else if (formating.charAt(i) == '.') {
        numberFormated += ',';
      } else {
        numberFormated += formating.charAt(i);
      }
    }
    return numberFormated;
  }

}